import React, { useEffect, useState } from "react";
import { Backdrop, CircularProgress, MenuItem } from "@material-ui/core";
import { Branch, Currency } from "../../containers/NewOrderContainer/types";
import DenominationsModalDialog from "../DenominationsModalDialog";
import DateInputField from "../DateInputField";
import getStyles from "./getStyles";

import "./NewOrderAndReturnForm.scss";
import moment from "moment";
import InputField from "../InputField";
import DropDown from "../DropDown/DropDown";
import { FormValue } from "./types";
import isEqual from "lodash/isEqual";
import Checkbox from "@material-ui/core/Checkbox";

const NewOrderAndReturnForm = (props: any) => {
  const [value, setValue] = useState<any>({});
  const [checked, setChecked] = useState<boolean>(false);
  const [openDenominationsModal, setOpenDenominationsModal] = useState<boolean>(
    false
  );
  const [isDirty, setDirty] = useState<boolean>(false);

  useEffect(() => {
    setDirty(props.isDirty);
  }, [props.isDirty]);

  useEffect(() => {
    if (!isEqual(props.value, value)) {
      setValue(props.value);
    }
  }, [props.value]);

  function updatedValueState(newValue: FormValue) {
    if (!isEqual(newValue, value)) {
      const openModal =
        newValue &&
        newValue.branchId !== undefined &&
        newValue.branchId !== null &&
        newValue.currency &&
        newValue.currencyAmount;

      setOpenDenominationsModal(!!openModal);
      setValue(newValue);
      props.onChange(newValue);
    }
  }

  function updateValue(payload: any) {
    if (payload && payload.branchId && props.onSelectBranch && props.branches) {
      // The check in this for action.payload existing is completely redundant,
      // However... typescript...
      const branch = props.branches.find(
        (b: Branch) => payload && b.id === payload.branchId
      );
      props.onSelectBranch(branch);
    }
    updatedValueState({
      ...value,
      ...payload
    });
  }

  const classes = getStyles();

  const [today, setToday] = useState<any>();
  useEffect(() => setToday(moment()), []);

  function getBranchName(branchId: number): string {
    const branch =
      props.branches && props.branches.find((b: Branch) => b.id === branchId);
    if (branch) {
      return branch.name;
    }
    return "";
  }

  function getCurrency(currencyId: number): string {
    if (props.currencies) {
      const currency = props.currencies.find(
        (c: Currency) => c.id === currencyId
      );
      if (currency) {
        return `${currency.region} - ${currency.name}`;
      }
    }
    return "";
  }

  let branchId: number | null | undefined = value && value.branchId;
  if (branchId !== 0 && !branchId) {
    branchId = null;
  }

  function isNotANumber(s: any) {
    return typeof s !== "number" || isNaN(s);
  }

  const currencyAmount: number | string = isNotANumber(
    value && value.currencyAmount
  )
    ? ""
    : (value.currencyAmount as number);

  const currencyAmountError =
    isDirty && currencyAmount === ""
      ? "Enter a currency amount"
      : currencyAmount !== "" &&
        (currencyAmount < 1 || currencyAmount > 99999999999999)
      ? "Must be 1 to 99,999,999,999,999"
      : "";

  const currentDenomTotal =
    value && value.denominations
      ? value.denominations.reduce((t: number, n: any) => t + n.orderValue, 0)
      : 0;

  const denominationsError =
    isDirty !== undefined && isDirty && value
      ? value.denominations === undefined ||
        (value.denominations && value.denominations.length === 0)
        ? "Select denominations"
        : Math.abs(currentDenomTotal - value.currencyAmount) < 0.00001
        ? ""
        : "Update denominations"
      : "";

  return (
    <>
      {!props.isLoadingInitialData ? (
        <div className="NewOrderAndReturnForm--inputs-container">
          <div className="NewOrderAndReturnForm--inputs-container-left">
            <DropDown
              containerClassName={"NewOrderAndReturnForm-Branch"}
              fieldName={"Branch"}
              value={branchId}
              renderValue={(branchId: any) => {
                if (branchId === null) {
                  return (
                    <MenuItem
                      className={classes.dropDownField}
                      disabled
                      key=""
                      value=""
                    >
                      Required
                    </MenuItem>
                  );
                } else {
                  return getBranchName(branchId);
                }
              }}
              onChange={(event: any) =>
                updateValue({
                  branchId: parseInt(event.target.value as string)
                })
              }
              errorOutline={
                isDirty !== undefined &&
                isDirty &&
                value &&
                value.branchId == null
              }
              dropDownItems={
                props.branches &&
                props.branches.map((branch: Branch, i: number) => (
                  <MenuItem
                    className={classes.dropDownField}
                    key={i}
                    value={branch.id}
                  >
                    {branch.name}
                  </MenuItem>
                ))
              }
              errorMessageClassName={"NewOrderAndReturnForm-BranchErrorMsg"}
              errorMessage={
                isDirty && value && value.branchId == null
                  ? "Choose a branch"
                  : ""
              }
              clickedActionButton={props.clickedActionButton}
            />

            <DropDown
              containerClassName={"NewOrderAndReturnForm-Currency"}
              fieldName={"Currency"}
              value={(value && value.currency) || ""}
              renderValue={(currency: any) => {
                if (currency === "") {
                  return (
                    <MenuItem
                      className={classes.dropDownField}
                      disabled
                      key=""
                      value=""
                    >
                      Required
                    </MenuItem>
                  );
                } else {
                  return getCurrency(currency);
                }
              }}
              onChange={(event: any) => {
                if (props.returns) {
                  updateValue({
                    currency: event.target.value as string
                  });
                } else {
                  updateValue({
                    currency: event.target.value as string,
                    denominations: []
                  });
                }
              }}
              errorOutline={
                isDirty !== undefined &&
                isDirty &&
                value &&
                value.currency === undefined
              }
              dropDownItems={
                props.currencies &&
                props.currencies.map((currency: Currency, i: number) => (
                  <MenuItem
                    className={classes.dropDownField}
                    key={i}
                    value={currency.id}
                  >
                    {currency.region} - {currency.name}
                  </MenuItem>
                ))
              }
              errorMessageClassName={"NewOrderAndReturnForm-CurrencyErrorMsg"}
              errorMessage={
                isDirty && value && value.currency === undefined
                  ? "Choose a currency"
                  : ""
              }
              clickedActionButton={props.clickedActionButton}
            />

            <InputField
              containerClassName={"NewOrderAndReturnForm-CurrencyAmount"}
              fieldName={"Currency Amount"}
              textFieldClassName={"NewOrderAndReturnForm-CurrencyAmount-text"}
              type={"number"}
              value={value && value.currencyAmount}
              inputProps={{ defaultValue: "0" }}
              placeHolder={"Required"}
              onChange={(event: any) => {
                setDirty(true);
                updateValue({
                  currencyAmount: Math.abs(parseFloat(event.target.value))
                });
              }}
              errorOutline={!!currencyAmountError}
              errorMessageClassName={
                "NewOrderAndReturnForm-CurrencyAmountErrorMsg"
              }
              errorMessage={currencyAmountError}
              clickedActionButton={props.clickedActionButton}
            />

            {!props.returns ? (
              <>
                <div className="NewOrderAndReturnForm--input-container NewOrderAndReturnForm-DenominationsButton">
                  <div className="NewOrderAndReturnForm--input-label">
                    Denominations
                  </div>
                  <DenominationsModalDialog
                    currency={
                      (value &&
                        props.currencies &&
                        props.currencies.find(
                          (x: any) => x.id === value.currency
                        )) ||
                      null
                    }
                    isLoadingDenominations={props.isLoadingDenominations}
                    currencyAmount={value && value.currencyAmount}
                    denominations={props.denominations}
                    openDenominationsModal={openDenominationsModal}
                    value={(value && value.denominations) || []}
                    onChange={(d: any) => {
                      setDirty(true);
                      updateValue({
                        denominations: d
                      });
                      if (props.onChangeDirty) {
                        props.onChangeDirty(true);
                      }
                    }}
                    error={denominationsError}
                    clickedActionButton={props.clickedActionButton}
                  />
                </div>

                <div className="NewOrderAndReturnForm--input-container">
                  <div className="NewOrderAndReturnForm--input-label">
                    <></>
                  </div>
                  <div className="NewOrderAndReturnForm--denominationsSummaryTextContainer">
                    {value &&
                      value.denominations &&
                      value.denominations.map((denomination: any) => (
                        <div className="NewOrderAndReturnForm--denominationsSummaryText">
                          {` ${denomination.orderValue.toString()} in ${
                            denomination.unitValue
                          }s`}
                        </div>
                      ))}
                  </div>
                </div>
              </>
            ) : (
              <></>
            )}

            <div className="NewOrderAndReturnForm--input-container NewOrderAndReturnForm-DatePicker">
              <div className="NewOrderAndReturnForm--input-label">
                Date Required
              </div>
              <div className="NewOrderAndReturnForm--date-picker-container">
                <DateInputField
                  className={`${classes.datePickerMargin} NewOrderAndReturnForm-DatePicker-field`}
                  value={value && value.selectedDate}
                  minDate={props.minRequiredDate}
                  maxDate={
                    props.maxRequiredDate ||
                    moment(props.minRequiredDate, "DD/MM/YYYY")
                      .add(90, "days")
                      .format("DD/MM/YYYY")
                  }
                  minDateMessage={
                    today &&
                    today.isBefore(moment(props.minRequiredDate, "DD/MM/YYYY"))
                      ? "Please select a future date"
                      : "Please select today or a future date"
                  }
                  maxDateMessage="Please select a date within the next 90 days"
                  onChange={(date: any) =>
                    updateValue({
                      selectedDate: date
                    })
                  }
                />
              </div>
            </div>
          </div>
          <div className="NewOrderAndReturnForm--inputs-container-right">
            <InputField
              containerClassName={"NewOrderAndReturnForm-Comments"}
              inputProps={{ maxLength: 100 }}
              fieldName={"Comments"}
              textFieldClassName={"NewOrderAndReturnForm-Comments-text"}
              type={"string"}
              value={(value && value.comments) || ""}
              onChange={(evt: any) =>
                updateValue({
                  comments: evt.target.value
                })
              }
              multiline={true}
              multilineRows={"4"}
            />
            <InputField
              containerClassName={"NewOrderAndReturnForm-TravellerBeneficiary"}
              inputProps={{ maxLength: 100 }}
              fieldName={"Traveller / Beneficiary"}
              textFieldClassName={
                "NewOrderAndReturnForm-TravellerBeneficiary-text"
              }
              type={"string"}
              value={(value && value.travellerBeneficiary) || ""}
              onChange={(evt: any) =>
                updateValue({
                  travellerBeneficiary: evt.target.value
                })
              }
            />
            <InputField
              containerClassName={"NewOrderAndReturnForm-InvoiceReference"}
              inputProps={{ maxLength: 100 }}
              fieldName={"Reference for Invoice"}
              textFieldClassName={"NewOrderAndReturnForm-InvoiceReference-text"}
              type={"string"}
              value={(value && value.referenceForInvoice) || ""}
              onChange={(evt: any) =>
                updateValue({
                  referenceForInvoice: evt.target.value
                })
              }
            />
            <div className="NewOrderAndReturnForm--input-container">
              <div className="NewOrderAndReturnForm--input-label">
                {props.returns ? "Collection address" : "Delivery address"}
              </div>
              <div className="NewOrderAndReturnForm-deliveryAddress">
                <div className="NewOrderAndReturnForm-contactName">
                  {props.deliveryAddress && props.deliveryAddress.contactName}
                </div>
                <div className="NewOrderAndReturnForm-streetAddress">
                  {props.deliveryAddress && props.deliveryAddress.streetAddress}
                </div>
                <div className="NewOrderAndReturnForm-city">
                  {props.deliveryAddress && props.deliveryAddress.city}
                </div>
                <div className="NewOrderAndReturnForm-county">
                  {props.deliveryAddress && props.deliveryAddress.county}
                </div>
                <div className="NewOrderAndReturnForm-postCode">
                  {props.deliveryAddress && props.deliveryAddress.postCode}
                </div>
              </div>
            </div>
            {props.isFcaCurrency ? (
              <div className="NewOrderAndReturnForm--input-container NewOrderAndReturnForm-fcaSettlement">
                <div className="NewOrderAndReturnForm--input-label">
                  Settle in Same Currency
                </div>
                <div>
                  <Checkbox
                    checked={checked}
                    onChange={(event: any) => {
                      updateValue({
                        settlementSource:
                          event.target.checked === true ? "1" : "0"
                      });
                      setChecked(event.target.checked);
                    }}
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      ) : (
        <div>
          <Backdrop className={classes.backdrop} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      )}
    </>
  );
};

export default NewOrderAndReturnForm;
